import React from "react";
import { useConfigurator } from "../context/ConfiguratorContext";
import { useTranslation } from "react-i18next";
import Utils from "../utils";
import utils from "../utils";

const TractorSidebar = () => {
  const { t } = useTranslation();

  const {
    selectedTractor,
    selectedTires,
    selectedUpgrades,
    selectedAttachments,
    selectedEquipment,
    selectedAccessories,
  } = useConfigurator();

  const tractorConfiguration = (data, singularLabel, pluralLabel) => {
    if (!data || data.length === 0) return null;

    return (
      <>
        <div className="border-line-row mb-3"></div>
        <p className="price-text-tires">
          {data.length === 1 ? t(singularLabel) : t(pluralLabel)}
        </p>
        {data?.map((item, index) => (
          <div
            key={index}
            className="price-text-tires-description d-flex justify-content-between mb-2"
          >
            <span>{item.name} : </span>
            <span className={`fw-bold text-danger`}>
              {item?.is_price_included === 1
                ? t(`free`)
                : Utils.priceNumberFormat(item.price)}
            </span>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="total-price-box-tires">
      <div className="total-price-content">
        <p className="mb-2 mt-2 total-price-text">
          {t("totalPrice") + ` : `}
          {utils.priceNumberFormat(
            (selectedTractor?.price || 0) +
              selectedTires.reduce((total, tire) => {
                return total + (tire.is_price_included === 0 ? tire.price : 0);
              }, 0) +
              selectedUpgrades.reduce((total, tire) => {
                return total + (tire.is_price_included === 0 ? tire.price : 0);
              }, 0) +
              selectedAttachments.reduce((total, tire) => {
                return total + (tire.is_price_included === 0 ? tire.price : 0);
              }, 0) +
              selectedEquipment.reduce((total, tire) => {
                return total + (tire.is_price_included === 0 ? tire.price : 0);
              }, 0) +
              selectedAccessories.reduce((total, tire) => {
                return total + (tire.is_price_included === 0 ? tire.price : 0);
              }, 0)
          )}
        </p>
      </div>
      <div className="border-line-row mb-3"></div>
      {selectedTractor ? (
        <>
          <p className="price-text-tires">
            {selectedTractor?.model + " " + selectedTractor?.name}
          </p>
          <p className="price-text-tires-description">
            {selectedTractor?.short_detail}
          </p>
          <p className="price-text-tires text-end text-danger">
            {Utils.priceNumberFormat(selectedTractor?.price)}
          </p>
        </>
      ) : (
        <>
          <p className="price-text-tires"></p>
          <p className="price-text-tires-description"></p>
        </>
      )}

      {tractorConfiguration(selectedTires, `tire`, `tires`)}

      {tractorConfiguration(selectedUpgrades, `upgrade`, `upgrades`)}

      {tractorConfiguration(selectedAttachments, `attachment`, `attachments`)}

      {tractorConfiguration(selectedEquipment, `equipment`, `equipment`)}

      {tractorConfiguration(selectedAccessories, `accessory`, `accessories`)}
    </div>
  );
};

export default TractorSidebar;
